import { fg } from '@atlaskit/platform-feature-flags/fg';

import { NLPSearchResultFormat } from '../ai-answer-dialog/nlp-search-result-format';
import type { NLPSearchResultSource, NLPSearchType } from '../ai-answer-dialog/types';

import { type DefinitionAgentResponse } from './types';

// DEFINITIONS
export const mapDefinitionMessageToNLPSearchType: (
	message: DefinitionAgentResponse,
	traceId?: string | null,
) => NLPSearchType = (message: DefinitionAgentResponse, traceId?: string | null): NLPSearchType => {
	return {
		nlpResult: message.content,
		uniqueSources: message.sources
			? message.sources.map(
					(source): NLPSearchResultSource => ({
						ari: source.ari,
						id: source.id?.toString(),
						title: source.title,
						product: source.product,
						type: source.type,
						url: source.url,
						lastModified: source.lastModified,
						iconUrl: null,
						spaceName: null,
						spaceUrl: null,
						...(source.connectorInfo &&
							fg('kd_definitions_connector_info_analytics') && {
								// Definitions provides the source product at the top level when connector metadata omits it.
								connectorInfo: {
									provider_id: source.connectorInfo.provider_id,
									connector_type: source.connectorInfo.connector_type,
									searchRetrievalType: source.connectorInfo.searchRetrievalType,
									sourceProduct: source.connectorInfo.sourceProduct ?? source.product ?? undefined,
								},
							}),
					}),
				)
			: [],
		disclaimer: null,
		errorState: null,
		format: NLPSearchResultFormat.MARKDOWN,
		extraAPIAnalyticsAttributes: {
			requestId: traceId ?? null,
			userQuery: message.human_message?.content ?? null,
			answerGenerationModel: message.usage_data ?? null,
			...(!fg('kd_consolidate_sources_analytics') && { sources: message.sources }),
			rawJson: message,
		},
	};
};
